import { ConsumersLoadStatusModel, EnumConsumersLoadStatus } from '@models/Consumers';

/** Registo do histórico do processo manual do perfil do comerciante na SIBS. */
export interface IExternalManualProcessEntry {
    Id?: string; // o endpoint não devolve identificador por registo
    IdMerchant: string;
    Status: ConsumersLoadStatusModel;
    Observation: string;
    RegistDate: string;
}

export interface IExternalManualProcessFilters {
    PageNumber: number;
    PageRows: number;
}

export interface IExternalManualProcessSaveModel {
    IdMerchant: string;
    IdStatus: EnumConsumersLoadStatus;
    Observation: string;
}

/** Estados selecionáveis (reutiliza `EnumConsumersLoadStatus`) e respetiva descrição. */
export const EXTERNAL_MANUAL_PROCESS_STATUS_NAMES: Record<number, string> = {
    [EnumConsumersLoadStatus.Pending]: 'Pendente',
    [EnumConsumersLoadStatus.InProgress]: 'Em curso',
    [EnumConsumersLoadStatus.PendingApproval]: 'Pendente de aprovação',
    [EnumConsumersLoadStatus.Accepted]: 'Aceite',
    [EnumConsumersLoadStatus.Finished]: 'Concluído',
    [EnumConsumersLoadStatus.Rejected]: 'Rejeitado',
    [EnumConsumersLoadStatus.Declined]: 'Recusado',
    [EnumConsumersLoadStatus.Canceled]: 'Cancelado',
    [EnumConsumersLoadStatus.Not_Syncronized]: 'Não sincronizado',
    [EnumConsumersLoadStatus.Idle]: 'Inativo'
};

export function BuildExternalManualProcessStatus(id: number, name?: string): ConsumersLoadStatusModel {
    return new ConsumersLoadStatusModel({ Id: id, Name: name || EXTERNAL_MANUAL_PROCESS_STATUS_NAMES[id] || null });
}
